module.exports = __webpack_public_path__ + "img/img_app_btm_03_feature1.0c877ce7.png";